import {
  Box,
  HStack,
  IconButton,
  Image,
  Spacer,
  Tooltip,
  Button,
  Text,
  useColorMode,
  useMediaQuery,
  useBreakpointValue,
} from "@chakra-ui/react";
import { FiMenu, FiDollarSign, FiGrid, FiMessageSquare } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { UserMenu } from "components/layout/UserMenu";

interface ChatNavbarProps {
  onOpen: () => void;
  navigate: (path: string) => void;
  credits: number;
  colorMode: string;
  borderColor: string;
}

export const ChatNavbar = ({
  onOpen,
  navigate,
  credits,
  colorMode,
  borderColor,
}: ChatNavbarProps) => {
  const { t } = useTranslation();
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? false;
  return (
    <Box
      p={2}
      borderBottom="1px"
      borderColor={borderColor}
      position="fixed"
      top={0}
      left={0}
      right={0}
      bg={
        colorMode === "dark"
          ? "rgba(0, 0, 0, 0.47)"
          : "rgba(255, 255, 255, 0.43)"
      }
      // blur transparent
      backdropFilter="blur(10px)"
      zIndex={10}
      w="100%"
    >
      <HStack spacing={1}>
        <HStack spacing={2}>
          <Image
            src={`/assets/img/logo-circle-${
              colorMode === "dark" ? "dark" : "light"
            }.svg`}
            alt="Araria"
            height="32px"
            width="32px"
            cursor="pointer"
            onClick={() => navigate("/")}
          />
          <IconButton
            aria-label="Menu"
            icon={<FiMenu />}
            onClick={onOpen}
            variant="ghost"
          />
        </HStack>
        <Spacer />
        <Tooltip label={t("chat.credits.view")} placement="bottom" hasArrow>
          <Button
            leftIcon={<FiDollarSign />}
            onClick={() => navigate("/usage")}
            variant="ghost"
            size="sm"
          >
            {isMobile ? (
              <Text fontSize="sm">{credits.toFixed(2)}</Text>
            ) : (
              t("chat.credits.balance", { amount: credits.toFixed(2) })
            )}
          </Button>
        </Tooltip>
        <Tooltip label={t("chat.dashboard.title")} placement="bottom" hasArrow>
          <IconButton
            aria-label={t("chat.dashboard.title")}
            icon={<FiGrid />}
            onClick={() => navigate("/dashboard")}
            variant="ghost"
          />
        </Tooltip>
        <Tooltip label={t("chat.chat.title")} placement="bottom" hasArrow>
          <IconButton
            aria-label={t("chat.chat.title")}
            icon={<FiMessageSquare />}
            onClick={() => navigate("/chat")}
            variant="ghost"
          />
        </Tooltip>
        <UserMenu />
      </HStack>
    </Box>
  );
};
